// extracted by mini-css-extract-plugin
export var gif = "_j0-0";